import PropTypes from 'prop-types';
import { List, Map } from 'immutable';

export const analyticsPageViewEvent = () => {
  if (window.dataLayer) {
    return window.dataLayer.push({
      event: 'pageView'
    });
  }

  return false;
};

export const analyticsCheckoutEvent = (event, step, cart) => {
  const products = cart
    .map(cartProducts => {
      const product = cartProducts.get('product', Map());
      return {
        id: product.get('id'),
        name: product.get('name'),
        price: product.get('price'),
        brand: product.getIn(['brand', 'name']),
        category: product.get('category'),
        quantity: cartProducts.get('quantity')
      };
    })
    .toArray();

  const eventObject = {
    event,
    currencyCode: 'SEK',
    actionField: {
      step
    },
    ecommerce: {
      checkout: {
        products
      }
    }
  };

  if (window.dataLayer) {
    return window.dataLayer.push(eventObject);
  }

  return false;
};

analyticsCheckoutEvent.propTypes = {
  eventName: PropTypes.string,
  listName: PropTypes.string,
  productList: PropTypes.instanceOf(List)
};

export const checkoutOptionEvent = id => {
  let actionField = {};
  if (id === 'a2900935-db16-4cfd-ba2e-a529317f4321') {
    actionField = { step: 1, option: 'Standard' };
  }
  if (id === 'a60cfdb6-c8a5-40df-8dca-e6fe9bf1f712') {
    actionField = { step: 2, option: 'Store' };
  }
  if (window.dataLayer) {
    return window.dataLayer.push({
      event: 'checkoutOption',
      ecommerce: {
        checkout_option: {
          actionField
        }
      }
    });
  }
  return false;
};

export const analyticsPurchaseEvent = (purchaseId, cart) => {
  const productList = cart
    .get('cart', Map())
    .map(item => ({
      name: item.getIn(['product', 'name']),
      id: item.getIn(['product', 'id']),
      price: item.getIn(['product', 'price']),
      brand: item.getIn(['product', 'brand', 'name']),
      category: item.get('categoryName'),
      quantity: item.get('quantity')
    }))
    .toArray();

  const eventObject = {
    event: 'purchase',
    ecommerce: {
      purchase: {
        actionField: {
          id: purchaseId,
          affiliation: 'Online Store',
          revenue: cart.get('grandTotalPrice'),
          tax: cart.get('vat'),
          shipping: typeof cart.get('deliveryCost') === 'number' ? cart.get('deliveryCost') : 0,
          coupon: cart.get('totalCampaignPrice')
        },
        products: productList
      }
    },
    eventCallback: () => document.location.pathname === '/tack'
  };

  if (window.dataLayer) {
    return window.dataLayer.push(eventObject);
  }

  return false;
};

analyticsPurchaseEvent.propTypes = {
  purchaseId: PropTypes.string.isRequired,
  cart: PropTypes.instanceOf(List).isRequired,
  revenue: PropTypes.number.isRequired,
  tax: PropTypes.number.isRequired,
  shipping: PropTypes.number.isRequired,
  coupon: PropTypes.number.isRequired
};

export const analyticsImpressionEvent = (eventName, listName, productList) => {
  let position = 0;
  const list = productList.toList();
  const impressionsList = list.map(
    baseProduct => {
      position += 1;

      return {
        name: baseProduct.get('name'),
        id: baseProduct.get('defaultVariantId'),
        price: baseProduct.get('price'),
        brand: baseProduct.getIn(['brand', 'name']),
        category: baseProduct.getIn(['category', 'name']),
        list: listName || baseProduct.getIn(['category', 'name']),
        position,
        dimension1: 'campaign price'
      };
    }
    // baseProduct.get('variants', List()).map(variant => {
    //   position += 1;
    //   return {
    //     name: variant.get('name'),
    //     id: variant.get('id'),
    //     price: variant.get('price'),
    //     brand: baseProduct.getIn(['brand', 'name']),
    //     category: baseProduct.getIn(['category', 'name']),
    //     list: listName,
    //     position,
    //     dimension1: 'campaign price'
    //   };
    // })
  );
  // .reduce((memory, item) => [...memory, ...item], []);

  const eventObject = {
    event: eventName,
    ecommerce: {
      impressions: impressionsList.toJSON()
    }
  };

  if (window.dataLayer) {
    return window.dataLayer.push(eventObject);
  }

  return false;
};

analyticsImpressionEvent.propTypes = {
  eventName: PropTypes.string,
  listName: PropTypes.string,
  productList: PropTypes.instanceOf(List)
};

export const analyticsDetailEvent = (eventName, product) => {
  const productList = [
    {
      name: product.get('name'),
      id: product.get('id'),
      price: product.get('price'),
      brand: product.getIn(['brand', 'name']),
      category: product.getIn(['category', 'name']),
      dimension1: 'campaign price'
    }
  ];

  const eventObject = {
    event: eventName,
    ecommerce: {
      detail: {
        actionField: {
          list: product.getIn(['category', 'name'])
        },
        products: productList
      }
    }
  };

  if (window.dataLayer) {
    return window.dataLayer.push(eventObject);
  }

  return false;
};

analyticsDetailEvent.propTypes = {
  eventName: PropTypes.string,
  product: PropTypes.instanceOf(Map)
};

export const analyticsProductClickEvent = (eventName, listName, product) => {
  const productList = [
    {
      name: product.get('name'),
      id: product.get('id'),
      price: product.get('price'),
      brand: product.getIn(['brand', 'name']),
      category: product.getIn(['category', 'name']),
      dimension1: 'campaign price'
    }
  ];

  const eventObject = {
    event: eventName,
    ecommerce: {
      click: {
        actionField: {
          list: listName,
          action: 'click'
        },
        products: productList
      }
    }
  };

  if (window.dataLayer) {
    return window.dataLayer.push(eventObject);
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/util/analyticEvents.js